import React from "react";
import { FaShieldAlt, FaStar, FaBolt } from "react-icons/fa";
import { MdVerified } from "react-icons/md";
import { replyLabel } from "../lib/listingFilters";
import "./TrustBadges.css";

/** Trust signals under a listing card: escrow · ID verified · rating · reply speed · new seller. */
// `hide` lets a card that already shows these next to the seller's name skip them here, e.g. hide={["verified", "rating"]}
export default function TrustBadges({ trust, hide = [] }) {
  if (!trust) return null;
  const verified = hide.includes("verified") ? false : trust.verified;
  const reviews = hide.includes("rating") ? 0 : trust.reviews;
  const { escrow, rating, replyMins } = trust;
  const newSeller = hide.includes("verified") ? false : trust.newSeller;
  const reply = replyLabel(replyMins);
  if (!escrow && !verified && !reviews && !reply && !newSeller) return null;
  return (
    <div className="tb-wrap">
      {(escrow || verified) && (
        <div className="tb-row">
          {escrow && <span className="tb tb-escrow" title="Pay safely: the seller only gets paid after you confirm the item"><FaShieldAlt /> Escrow protected</span>}
          {verified && <span className="tb tb-ver" title="This seller's ID has been verified"><MdVerified /> ID verified</span>}
        </div>
      )}
      {(reviews > 0 || reply || (newSeller && !escrow)) && (
        <div className="tb-row tb-meta">
          {reviews > 0 && <span className="tb-rate" title={`${reviews} review${reviews === 1 ? "" : "s"} from completed orders`}><FaStar /> {rating?.toFixed(1)} <i>({reviews})</i></span>}
          {reply && <span className="tb-reply"><FaBolt /> {reply}</span>}
          {newSeller && !reviews && <span className="tb-new">New seller</span>}
        </div>
      )}
    </div>
  );
}
